import React, { useState } from "react";
import { Formik } from "formik";
import { Button, Grid, FormControl, InputAdornment, InputLabel, OutlinedInput, CircularProgress } from "@material-ui/core";
import { panelUsersAuthStyle } from "../../panelUsersAuthStyle";
import { useDispatch } from "react-redux";

export const EditUserAuth = ({ edit, clearData, data }) => {
    const classes = panelUsersAuthStyle();
    const [isLoanding, setisLoanding] = useState(false)
    const [, dispath] = useDispatch()

    return (
        <Formik

            initialValues={{
                nombre: data.name,
                telefono: data.phone,
                email: data.email,
                userName: data.username,
                // rol: data.roles[0].name,
                // pass: ""
            }}

            validate={(valores) => {

                let errores = {};

                if (!valores.nombre) {
                    errores.nombre = 'Por favor ingresa un nombre'
                } else if (!/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(valores.nombre)) {
                    errores.nombre = 'No se aceptan caracteres especiales ni números'
                }

                // if (!valores.telefono) {
                //     errores.descripcion = 'Por favor ingresa una telefono'
                // } else if (!/^[0-9]{1,40}$/.test(valores.telefono)) {
                //     errores.telefono = 'No se aceptan caracteres especiales ni letras'
                // }

                if (!valores.email) {
                    errores.email = 'Por favor ingresa una email'
                } else if (!/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(valores.email)) {
                    errores.email = 'Use un formato de email valido'
                }

                if (!valores.userName) {
                    errores.userName = 'Por favor ingresa un userName'
                } else if (!/^[a-zA-Z0-9_.+-]{1,40}$/.test(valores.userName)) {
                    errores.userName = 'Solos se aceptan letras guiones y  números'
                }

                
                // if (!valores.rol) {
                //     errores.rol = 'Por favor ingresa un userName'
                // } else if (!/^[a-zA-Z0-9_.+-]{1,40}$/.test(valores.rol)) {
                //     errores.rol = 'Solos se aceptan letras guiones y  números'
                // }

                
                // if (!valores.pass) {
                //     errores.pass = 'Por favor ingresa un userName'
                // } else if (!/^[a-zA-Z0-9_.+-]{8,10}$/.test(valores.pass)) {
                //     errores.pass = 'La contraseña debe tener minimo 8 caracteres'
                // }

                return errores;

            }}

            onSubmit={(valores, { resetForm }) => {
                setisLoanding(true)
                const request = {

                    id: data.id,
                    name: valores.nombre, 
                    username:valores.userName, 
                    email:valores.email, 
                    opt: "", 
                    celular: valores.telefono
                    
                }
                edit(request);
                setTimeout(() => {  
                    setisLoanding(false)
                    clearData()
                    resetForm();
                }, 800);                
            }}
        >
            {({ values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3} style={{ textAlign: "left" }}>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="nombre">Nombre</InputLabel>
                                <OutlinedInput
                                    id="nombre"
                                    type="text"
                                    name='nombre'
                                    defaultValue={values.nombre}
                                    value={values.nombre}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                />
                            </FormControl>
                            {touched.nombre && errors.nombre && <div style={{ color: "red" }}>{errors.nombre}</div>}
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="nombre">Telefono</InputLabel>
                                <OutlinedInput
                                    id="telefono"
                                    type="text"
                                    name='telefono'
                                    defaultValue={values.telefono}
                                    value={values.telefono}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                />
                            </FormControl>
                            {touched.telefono && errors.telefono && <div style={{ color: "red" }}>{errors.telefono}</div>}
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="nombre">Email</InputLabel>
                                <OutlinedInput
                                    id="email"
                                    type="mail"
                                    name='email'
                                    defaultValue={values.email}
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                />
                            </FormControl>
                            {touched.email && errors.email && <div style={{ color: "red" }}>{errors.email}</div>}
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="nombre">User Name</InputLabel>
                                <OutlinedInput
                                    id="userName"
                                    type="text"
                                    name='userName'
                                    defaultValue={values.userName}
                                    value={values.userName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                />
                            </FormControl>
                            {touched.userName && errors.userName && <div style={{ color: "red" }}>{errors.userName}</div>}
                        </Grid>
                        {/* <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="tipo">Rol</InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="rol"
                                    name="rol"
                                    defaultValue={values.rol}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Desea recibir emails"
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="ROLE_USER">Usuario</MenuItem>
                                    <MenuItem value="ROLE_ADMIN">Admin</MenuItem>
                                </Select>
                            </FormControl>
                            {touched.rol && errors.rol && <div style={{ color: "red" }}>{errors.rol}</div>}
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="nombre">Contraseña</InputLabel>
                                <OutlinedInput
                                    autocomplete="off"
                                    id="pass"
                                    type="password"
                                    name='pass'
                                    defaultValue={values.pass}
                                    value={values.pass}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                />
                            </FormControl>
                            {touched.pass && errors.pass && <div style={{ color: "red" }}>{errors.pass}</div>}
                        </Grid> */}
                    </Grid>
                    <div className={classes.wrapper}>
                        <Grid container justifyContent="center" style={{ marginTop: '10px' }}>
                            <Button
                                disabled={isLoanding}
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ textTransform: "none", width: "100%" }}
                            >
                                Editar usuario
                            </Button>
                        </Grid>
                        {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </form>
            )}
        </Formik>
    );
}